import {
    chakra,
    Flex,
    Box
} from '@chakra-ui/react';

export const Landing = chakra(Box, {
    baseStyle: {
        display: 'block',
        w: '100%',
        h: 'calc(100vh - 60px)',
        backgroundColor: 'neutral.100'
    }
});

export const Container = chakra(Flex, {
    baseStyle: {
        flexDirection: 'column',
        height: '100%'
    }
});
